import styled from 'styled-components';

export const MainTabSection = styled.section`
   background: #F1FEFF 0% 0% no-repeat padding-box;
   padding:50px 0;
    @media screen and (max-width:991px){
      padding-top:150px;
    }
   .nav-tabs{
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 20px 20px #0000001A;
    border-radius: 15px;
    padding: 6px;
    justify-content: space-between;
    margin-bottom: 37px;
       .nav-item{ 
        margin: 0 4px 0 0;
        &:last-child{ 
            .nav-link{
                border-right:none;
              }
            }
            .nav-link{
                color: #01606F;
                font-family: "Jost", sans-serif;
                font-size:16px;
                font-weight: 500;
                line-height: 23px; 
                padding: 13px 10px;
                border: none;
                 border-radius: 10px;
                
                &.active,&:hover{
                  background: #01606F 0% 0% no-repeat padding-box;
                  color:#fff;
               } 
            }
       }
   }


   @media (max-width: 767px) {
    .responsive-tabs {
      flex-wrap: wrap;
    }
  
    .responsive-tabs .nav-link {
      flex-basis: 50%;
  
      text-align: center;
    }
  }
`;

export const TabTitle = styled.h2`
    width: 100%;
    color: #01606F;
    font-size: 40px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 58px;
    margin-bottom: 30px;
`;

export const ReviewTabDetailWrap = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    column-gap: 24px;
    @media screen and (max-width:767px){
      flex-wrap: wrap;
      gap: 28px;
    }
`;

export const ProfileBox = styled.div`
    max-width: 282px;
    width:100%;
    // @media screen and (max-width:991px){
    //  max-width:100%;
    // width:100%;
    // }
`;

export const NonProfitReviewBox = styled.div`
 
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;

    .review-uploaded-image{
        display: none;
    }
`;

export const SearchCardBoxReview = styled.div`
  width: 100%;
  max-width: 894px;
  display: flex;
  flex-direction: column;
  row-gap: 20px !important;
  justify-content: flex-start;
  align-items: flex-start;
`;

